import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    mapDispatchToProps as advoxmapDispatchToProps,
    mapStateToProps as advoxMapStateToProps,
    ProductAdditionalInfoContainer as AdvoxProductAdditionalInfoContainer,
} from 'AdvoxComponent/ProductAdditionalInfo/ProductAdditionalInfo.container';
import { CUSTOMER_ACCOUNT_OVERLAY_KEY } from 'Component/MyAccountOverlay/MyAccountOverlay.config';
import { toggleOverlayByKey } from 'Store/Overlay/Overlay.action';

import ProductAdditionalInfo from './ProductAdditionalInfo.component';

/** @namespace Pwa/Component/ProductAdditionalInfo/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...advoxMapStateToProps(state),
    customer: state.MyAccountReducer.customer,
    shippingTime: state.ConfigReducer.advox_shipping_time_shipping_time,
    shippingTimeEnabled: state.ConfigReducer.advox_shipping_time_enabled,
    inpostFreeAbove: state.ConfigReducer.inpost_free_above,
    inpostEnabled: state.ConfigReducer.inpost_enabled,
    inpostName: state.ConfigReducer.inpost_name,
    isMobile: state.ConfigReducer.device.isMobile,
    isTablet: state.ConfigReducer.device.isTablet,
});
/** @namespace Pwa/Component/ProductAdditionalInfo/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...advoxmapDispatchToProps(dispatch),
    showOverlay: (overlayKey) => dispatch(toggleOverlayByKey(overlayKey)),
});

/** @namespace Pwa/Component/ProductAdditionalInfo/Container */
export class ProductAdditionalInfoContainer extends AdvoxProductAdditionalInfoContainer {
    static propTypes = {
        ...this.propTypes,
        showOverlay: PropTypes.func.isRequired,
        shippingCosts: PropTypes.object.isRequired,
        shippingCostsAdditional: PropTypes.array.isRequired,
        productPrice: PropTypes.number.isRequired,
    };

    containerFunctions = {
        openDrawer: this.openDrawer.bind(this),
        closeDrawer: this.closeDrawer.bind(this),
        onMyAccountButtonClick: this.onMyAccountButtonClick.bind(this),
    };

    onMyAccountButtonClick() {
        const { showOverlay } = this.props;

        showOverlay(CUSTOMER_ACCOUNT_OVERLAY_KEY);
    }

    containerProps() {
        const {
            showAlternativeDesign,
            shippingCostsAdditional,
            shippingCosts,
            customer,
            shippingTime,
            shippingTimeEnabled,
            productPrice,
            inpostFreeAbove,
            inpostEnabled,
            inpostName,
            isMobile,
            isTablet,
        } = this.props;
        const { isLoggedIn } = this.state;

        return {
            inpostEnabled,
            inpostName,
            productPrice,
            inpostFreeAbove,
            showAlternativeDesign,
            isLoggedIn,
            customer,
            shippingTime,
            shippingTimeEnabled,
            shippingCosts,
            shippingCostsAdditional,
            isMobile,
            isTablet,
        };
    }

    render() {
        return <ProductAdditionalInfo {...this.containerProps()} {...this.containerFunctions} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductAdditionalInfoContainer);
